import { useTranslation } from "react-i18next";
import { normLang } from "@/i18n";

// Bilingual inline helper for the Agents module: tr("Texte FR", "EN text").
export function useTr() {
  const { i18n } = useTranslation();
  const lang = normLang(i18n.language) === "en" ? "en" : "fr";
  const tr = (fr, en) => (lang === "en" ? en : fr);
  tr.lang = lang;
  return tr;
}

export const fmtDate = (iso, lang) => (iso ? new Date(iso).toLocaleString(lang === "en" ? "en-GB" : "fr-FR") : "—");
